import { render, staticRenderFns } from "./OrganisationSearchField.vue?vue&type=template&id=1f8a3f08&scoped=true"
import script from "./OrganisationSearchField.vue?vue&type=script&lang=ts"
export * from "./OrganisationSearchField.vue?vue&type=script&lang=ts"
import style0 from "./OrganisationSearchField.vue?vue&type=style&index=0&id=1f8a3f08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8a3f08",
  null
  
)

export default component.exports